module.exports = __webpack_public_path__ + "img/abstract2.7473afde.jpg";